import React from "react";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";

/**
 * Global footer — appears on every page including the 404. Required
 * by Canadian consumer-protection norms (operator disclosure) and
 * ePrivacy convention (cookie prefs link must remain accessible).
 *
 * Keeps existing attribution ("© 2026 LEAGUE HUB • Powered by Squad
 * Seeker") + the original Discord / What's New / Admin links, but
 * adds the legal nav row above them.
 */
export function LegalFooter({ onWhatsNew }) {
  const openCookiePrefs = (e) => {
    e.preventDefault();
    window.dispatchEvent(new Event("lh:cookie-prefs:open"));
  };
  return (
    <footer
      className="page-z border-t border-[#14b8a6]/20 mt-10"
      data-testid="global-footer"
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8 flex flex-col gap-5">
        {/* Legal nav row */}
        <nav
          data-testid="footer-legal-nav"
          className="flex flex-wrap gap-x-5 gap-y-2 text-[11px] tracking-wide text-white/55"
        >
          <Link to="/legal/privacy"       className="hover:text-[#14b8a6]" data-testid="footer-legal-privacy">Privacy</Link>
          <Link to="/legal/terms"         className="hover:text-[#14b8a6]" data-testid="footer-legal-terms">Terms</Link>
          <Link to="/legal/cookies"       className="hover:text-[#14b8a6]" data-testid="footer-legal-cookies">Cookies</Link>
          <Link to="/legal/community"     className="hover:text-[#14b8a6]" data-testid="footer-legal-community">Community</Link>
          <Link to="/legal/subscriptions" className="hover:text-[#14b8a6]" data-testid="footer-legal-subscriptions">Subscription Terms</Link>
          <Link to="/legal/withdrawal"    className="hover:text-[#14b8a6]" data-testid="footer-legal-withdrawal">Cancellation &amp; Refunds</Link>
          <Link to="/legal/contact-info"  className="hover:text-[#14b8a6]" data-testid="footer-legal-info">Legal Info</Link>
          <Link to="/contact"             className="hover:text-[#14b8a6]" data-testid="footer-legal-contact">Contact</Link>
          <a
            href="#"
            onClick={openCookiePrefs}
            data-testid="footer-cookie-prefs"
            className="hover:text-[#14b8a6]"
          >
            Cookie prefs
          </a>
        </nav>

        {/* Bottom row — attribution + community */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p
            className="text-sm text-white/50"
            data-testid="footer-powered-by"
          >
            © 2026 LEAGUE HUB • Powered by Squad Seeker
          </p>
          <div className="flex flex-wrap items-center gap-4">
            <SocialLinks />
            <a
              href="https://discord.gg/NUB8Td6AS5"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-discord-link"
              title="Join the LEAGUE HUB community Discord"
              className="text-xs tracking-widest text-[#5865F2] hover:text-[#a3a3ac] flex items-center gap-1"
            >
              <i className="fab fa-discord text-base" />JOIN DISCORD
            </a>
            <button
              type="button"
              onClick={onWhatsNew}
              data-testid="footer-whats-new"
              className="text-xs text-white/40 tracking-widest hover:text-[#14b8a6]"
            >
              <i className="fas fa-shield text-[#14b8a6] mr-1" /> CRT MODE • V1.0.0 • ✨ WHAT'S NEW
            </button>
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-xs text-white/30 tracking-widest hover:text-[#14b8a6]"
              title="Admin panel"
            >
              <i className="fas fa-shield-halved mr-1" />ADMIN
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LegalFooter;
